// extracted by mini-css-extract-plugin
export default {"table-container":"TableSkeleton_table-container__Ty+Vk","table":"TableSkeleton_table__+1Gjr","badge":"TableSkeleton_badge__GIO74"};